/**
 * The list she picked before her party existed.
 *
 * An import needs an event to import into, so the file waits here for the few
 * hundred milliseconds between "Criar festa" and the preview screen. It never
 * touches storage: a class list should not sit in localStorage waiting to be
 * forgotten about.
 */

let pending: File | null = null;

export function holdFile(file: File | null): void {
  pending = file;
}

/** Reading it takes it: a stale list must not attach itself to the next party. */
export function takeFile(): File | null {
  const file = pending;
  pending = null;
  return file;
}
